<template>
  <div class="personCenter">
    <div class="bgLogo">
      <div class="bgImg">
        <div class="pageTitle">个人中心</div>
        <img src="@/assets/img/bjing@2x.png" alt="" />
      </div>
    </div>
    <div class="personList">
      <p v-for="item in personList" :key="item.url" @click="goPage(item)">
        <img :src="require(`../../assets/img/${item.img}`)">
        <span>{{ item.name }}</span>
      </p>
      <p @click="ModifyingInfo">
        <img :src="require(`../../assets/img/2@2x.png`)">
        <span>修改报名信息</span>
      </p>
      <p @click="revokeInfor">
        <img :src="require(`../../assets/img/1@2x.png`)">
        <span>撤销报名信息</span>
      </p>
      <p @click="admissionNotice">
        <img :src="require(`../../assets/img/3@2x.png`)">
        <span>入学通知书</span>
      </p>
      <p @click="showCard">
        <img :src="require(`../../assets/img/4@2x.png`)">
        <span>电子学生卡</span>
      </p>
    </div>
    <!-- 电子学生卡 -->
    <van-overlay :show="showOverlay">
      <div class="wrapper"  @click="() => { showOverlay = false }">
        <div class="block" id="printcontent" @click.stop>
          <div class="blockTitle">
            <p class="theme">学生卡</p>
            <div class="operation">
              <p class="download" @click="downloadStudentCards">下载</p>
              <van-icon name="cross" class="cancel" @click="() => { showOverlay = false }" />
            </div>
          </div>
          <div class="card">
            <div class="QRcode">
              <img :src="studentCardurl">
            </div>
            <div class="StudentName">{{statusByUser.stuName}}</div>
            <div class="StudentId">{{statusByUser.sid}}</div>
            <div class="StudentMajor">{{statusByUser.shortName}}</div>
            <div class="StudentYear">{{statusByUser.yearsName}}</div>
            <div class="BranchCampuses">{{statusByUser.orgName}}</div>
            <div class="TeachingCenter">{{statusByUser.schoolName}}</div>
          </div>
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import  { deleteEnrollingStudent, getStudentStatusByUserId, genQrCodeRol } from '@/api/login'
import setting from '../../../utils/setting';
import axios from 'axios'
import { Toast } from "vant";
// import {Dialog, showConfirmDialog } from 'vant'
import { Dialog } from 'vant'
import store from '@/store'
export default {
  name: "Sign",
  data() {
    return {
      studentNo: '',
      showOverlay: false,
      personList: [
        {name: '注册报名',url: '/registrateProgress',img: '1@2x.png'},
        {name: '我的学籍',url: '/myAcademic',img: '2@2x.png'}
        // {name: '我的课程',url: ''},
        // {name: '我的提问',url: ''}
      ],
      statusByUser:{},
      studentCardurl: ''
    }
  },
  created() {
    this.studentNo = this.$store.state.studentNo
    if (this.studentNo) {
      const newUrl = [
        {name: '我的课程',url: '/myCourse',img: '3@2x.png'},
        {name: '我的成绩',url: '/myCouseAchievement',img: '4@2x.png'},
      ]
      this.personList = [...this.personList,...newUrl]
      getStudentStatusByUserId(this.studentNo).then(res=>{
        this.statusByUser = res;
      })
    }
  },
  methods: {
    // if () {
    goPage(item) {
      if (item.isOther) {// 请求接口
        // 我的课程
       window.open(`${setting.baseOtherUrl}/login/zhsLogin?username=${this.studentNo}&token=${store.state.token}&clientId=960184123115175936`)
      }else {
        if (!this.$store.state.userId) {
          return
        }
        this.$router.push({path: item.url})
      }
      
    },
    // 修改报名信息
    ModifyingInfo() {
      if (!this.$store.state.userId) {
        return
      }
      if (Number(this.$store.state.approvalStatus) > 1) {
        Toast({
          message: "您所报读的教学中心，已审核通过您的注册申请，不可修改报名信息",
          position: "top",
        });
        return 
      }
      this.$router.push({path: '/home',query: {studentId: this.$store.state.userId}})
    },
    // 撤销报名信息
    revokeInfor() {
      if (!this.$store.state.userId) {
        return
      }
      if (Number(this.$store.state.approvalStatus) > 1) {
        Toast({
          message: "您所报读的教学中心，已审核通过您的注册申请，不可撤销报名信息",
          position: "top",
        });
        return 
      }
      Dialog({
        showConfirmButton: true,
        showCancelButton: true,
        confirmButtonColor: '#323233',
        title: '确定撤销报名信息'
      })
      .then(() => {
        deleteEnrollingStudent({userUniqueId: this.$store.state.userUniqueId}).then(res=>{
          Toast({
            message: "撤销成功",
            position: "top",
          });
          this.$router.push({path: '/login'})
        })
      })
    },
    // 获取下载接口时loading图
    showToastloading() {
      Toast.loading({
        message: "正在下载",
        duration: 0, // 持续展示 toast
        forbidClick: true,
        loadingType: 'spinner',
      });
    },
    // 获取电子学生卡
    showCard() {
      axios.get(`${setting.baseOtherTwoUrl}edu/indeximg/genQrCodeRoll`,{
        params: {
          sid:this.studentNo
        },
        headers: {
          'token': this.$store.state.token, // 确保你的store和state已经被正确初始化  
          'user_id': this.$store.state.userId, // 同上 
          'Content-Type': 'application/json'
        },
        // responseType: 'arraybuffer'
      }).then(res => {
        this.studentCardurl = res.data.data
      })
      
      this.showOverlay = true;
    },
    // 下载电子学生卡 // enroll/student/downloadStudentCard
    downloadStudentCards() {
      this.showToastloading()
        // 请求
				axios({
					method: "get",
					url: setting.baseUrl  + `/student/downloadStudentCard?sid=${this.$store.state.studentNo}`,
					responseType: "blob",
					headers: {
						'token': this.$store.state.token,
            'user_id': this.$store.state.userId, 
						"Content-Type": "application/json; application/octet-stream",
					},
				})
				.then((response) => {
					const url = window.URL.createObjectURL(new Blob([response.data]));
					const aLink = document.createElement("a");
					aLink.href = url;
					let name = response.headers["content-disposition"]
            .split(";")[1]
            .split("=")[1];
          aLink.setAttribute("download", decodeURI(name));
					document.body.appendChild(aLink);
					aLink.click();
					document.body.removeChild(aLink);
					window.URL.revokeObjectURL(url);
          Toast.clear(); // 手动清除 Toast
				})
				.catch(function(error) {
				});
    },
    // 导出入学通知书
    admissionNotice() {
        // loading图
       this.showToastloading()
        // 请求
				axios({
					method: "get",
					url: setting.baseUrl  + `student/downloadStudentAdmissionNoticePDF?studentNo=${this.$store.state.studentNo}`,
					// data: {studentNo: },
					responseType: "blob",
					headers: {
						'token': this.$store.state.token,
            'user_id': this.$store.state.userId, 
						"Content-Type": "application/json; application/octet-stream",
					},
				})
				.then((response) => {
					const url = window.URL.createObjectURL(new Blob([response.data]));
					const aLink = document.createElement("a");
					aLink.href = url;
					let name = response.headers["content-disposition"]
            .split(";")[1]
            .split("=")[1];
          aLink.setAttribute("download", decodeURI(name));
					document.body.appendChild(aLink);
					aLink.click();
					document.body.removeChild(aLink);
					window.URL.revokeObjectURL(url);
          Toast.clear(); // 手动清除 Toast
				})
				.catch(function(error) {
          console.log(error);
          Toast.clear(); // 清除 loading
          let msg =  '学号不能为空';
          Toast.fail(msg);
				});
		}
  },
};
</script>
<style scoped>
.bgImg {
  position: relative;
  width: 100%;
  height: 272px;
  z-index: 0;
}
.bgImg img {
  width: 100%;
  height: 100%;
}
.bgImg .pageTitle {
  position: absolute;
  top: 82px;
  left: 26px;
  font-size: 25px;
  font-weight: bold;
  color: #FFFFFF;
}
.appName {
  width: 171px;
  background-color: #ffffff4b;
  text-align: center;
  height: 24px;
  line-height: 24px;
  border-radius: 40px;
  font-size: 16px;
  font-weight: 400;
  color: #ffffff;
  position: absolute;
  top: 104px;
  left: 50%;
  transform: translate(-50%, 0);
}
.personList {
  position: relative;
  top: -138px;
  line-height: 25px;
  margin: 0 9px 10px;
  border-radius: 8px;
  padding: 4px 15px 18px;
  background-color: #ffffff;
  height: calc(100vh - 138px);

}
.personList p {
  display: flex;
  align-items: center;
  height: 58px;
  font-size: 14px;
  color: #333333;
  border-bottom: 1px solid #ddd;
}
.personList p img {
  width: 14px;
  height: 14px;
  margin-right: 10px;
  margin-bottom: 3px;
}

.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.block {
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 90vw;
  height: 62vw;
  background-color: #fff;
  border-radius: 2vw;
  overflow: hidden;
}

.block .blockTitle {
  width: 100%;
  height: 10vw;
  line-height: 10vw;
  font-size: 4vw;
  font-weight: 600;
  color: #fff;
  background: rgb(174, 25, 25);
  margin-bottom: 1vw;
  display: flex;
}

.blockTitle .theme {
  flex: 4;
  text-align: end;
}

.blockTitle .operation {
  flex: 3;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  font-size: 3vw;
  box-sizing: border-box;
}

.blockTitle .operation .download {
  width: 10vw;
  text-align: center;
  margin-right: 5vw;
}

.blockTitle .operation .cancel {
  width: 5vw;
  text-align: center;
}

.block .card {
  width: 98%;
  height: 50vw;
  background: url('../../assets/img/ElectronicStudentCard.png') no-repeat;
  background-size: 100% 100%;
  position: relative;
  color: #f5f5f5;
  font-size: 2.5vw;
  font-weight: 600;

}
.card .StudentName {
  position: absolute;
  top: 16.4vw;
  left: 21vw;
  opacity: .9;
}

.card .StudentId {
  position: absolute;
  top: 16.3vw;
  left: 60vw;
  opacity: .9;
}

.card .StudentMajor {
  position: absolute;
  top: 22.8vw;
  left: 21vw;
  opacity: .9;
}

.card .StudentYear {
  position: absolute;
  top: 22.6vw;
  left: 60vw;
  opacity: .9;
}

.card .BranchCampuses {
  position: absolute;
  top: 29.7vw;
  left: 21vw;
  opacity: .9;
}

.card .TeachingCenter {
  position: absolute;
  top: 37.3vw;
  left: 21vw;
  opacity: .9;
}

.card .QRcode {
  position: absolute;
  top: 33.5vw;
  left: 70.5vw;
  width: 13vw;
  height: 13vw;
  background: #f5f5f5;
}

.QRcode img {
  width: 100%;
  height: 100%;
}


</style>
